/*
 * Created by: cparaschiv
 * Date: 18.12.2012, 17:21
 */

/** @ignore */
TS.viewModel.ResponseMessage = new Class({

    initialize: function(config){

        this.type = (config && config.Type) || TS.viewModel.MessageType.Information;
        this.errors = (config && config.Errors) || [];
    }

});